export default __webpack_public_path__ + "static/media/icon_payout.66ebf51a.svg";